/**
 *    SESSION REPOSITORY
 *
 * 		REACT NOTE: trimmed this down to set/get browser session objects
 * 		no longer using this as an in-memory User / Session store (see ng.delegate)
 * 		trying to eliminitate multiple locations for stored data only into ng.delegate
 */

import validSvc from '../validSvc';

const sessionRepo = {
    set: set,
    get: get,
    clearKey: clearKey,
    clear: clear,
    setLocalStoreKey: setLocalStoreKey,
    getLocalStoreKey: getLocalStoreKey,
    clearLocalStore: clearLocalStore,
};

function set(keyName: string, newVal: object): void {
    // react note: not using User, deepLink, token set in React

    if (validSvc.isText(keyName) && !!newVal) {
        window.sessionStorage.setItem(keyName, JSON.stringify(newVal));
    }
}

/* @ts-expect-error do-not-change */
function get(keyName: string, ctx?: object): SessionStoreObject | string | null | any {
    // react note: not using in-memory session, User, deepLink or token

    /* @ts-expect-error do-not-change */
    const keyVal: SessionStoreObject | null | string = loadStore(keyName);
    if (keyVal == null) {
        return null;
    }

    // match incoming context to saved context
    if (!!ctx && typeof keyVal != 'string' && !!keyVal.ctx) {
        for (const propName in ctx) {
            if (ctx.hasOwnProperty(propName)) {
                if (!keyVal.ctx.hasOwnProperty(propName) || ctx[propName] !== keyVal.ctx[propName]) {
                    // ctx is old, clear keyName, return nothing
                    clearKey(keyName);
                    return null;
                }
            }
        }
    }

    // success
    return keyVal;
}

function clearKey(key): void {
    if (!!window.sessionStorage && validSvc.isText(key)) {
        try {
            window.sessionStorage.removeItem(key);
        } catch (err) {
            // do nothing
        }
    }
}

function clear(): void {
    if (!!window.sessionStorage) {
        window.sessionStorage.clear();
    }
}

/**
 * 		LOCAL STORAGE
 */

function setLocalStoreKey(keyName, val): boolean {
    if (!!window.localStorage && validSvc.isText(keyName) && !!val) {
        window.localStorage.setItem(keyName, JSON.stringify(val));
        return true;
    }
    return false;
}

function getLocalStoreKey(keyName: string): null | string | [] | object {
    let result = null;
    if (!!window.localStorage && validSvc.isText(keyName)) {
        const val = window.localStorage.getItem(keyName);
        if (!!val && validSvc.isText(val)) {
            try {
                result = JSON.parse(val);
            } catch (err: any) {
                console.log('sessionRepo.getLocalStoreKey, JSON parse error: ' + err.message);
            }
        }
    }
    return result;
}

function clearLocalStore(): void {
    if (!!window.localStorage) {
        window.localStorage.clear();
    }
}

/**
 *    HELPERS
 */

/* @ts-expect-error do-not-change */
function loadStore(storeKey: string): SessionStoreObject | null | string {
    /* @ts-expect-error do-not-change */
    let result: SessionStoreObject | null = null;

    try {
        const windowSession: string = window.sessionStorage.getItem(storeKey) || '';
        if (validSvc.isText(windowSession)) {
            // all session keys will be json
            result = JSON.parse(windowSession);
        }
    } catch (err) {
        // do nothing
    }

    return result;
}

export default sessionRepo;
